import * as Icons from "lucide-react";
import { FadeIn } from "./FadeIn";
import { USPS } from "@/lib/site";

const resolveIcon = (name) => Icons[name] || Icons.Sparkles;

export const WhyUs = () => {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="relative py-24 sm:py-32 bg-brand-surface"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <FadeIn>
            <p className="text-xs sm:text-sm uppercase tracking-[0.3em] text-brand-accent font-semibold mb-5">
              Why SK-ANNU
            </p>
          </FadeIn>
          <FadeIn delay={0.1}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brand-primary leading-[1.05]">
              Four promises. <span className="italic">Zero compromise.</span>
            </h2>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-brand-borderColor rounded-2xl overflow-hidden border border-brand-borderColor">
          {USPS.map((u, i) => {
            const Icon = resolveIcon(u.icon);
            return (
              <FadeIn key={u.title} delay={i * 0.1}>
                <div
                  className="h-full bg-brand-base p-8 lg:p-10 flex flex-col gap-5 hover:bg-[#FDFBF7] transition-colors duration-300"
                  data-testid={`usp-${u.title.replace(/\s+/g, "-").toLowerCase()}`}
                >
                  <span className="h-12 w-12 rounded-full bg-brand-primary/5 border border-brand-primary/10 flex items-center justify-center text-brand-primary">
                    <Icon size={22} strokeWidth={1.5} />
                  </span>
                  <div>
                    <h3 className="font-display text-xl text-brand-primary">
                      {u.title}
                    </h3>
                    <p className="mt-3 text-sm text-brand-textMuted leading-relaxed">
                      {u.body}
                    </p>
                  </div>
                </div>
              </FadeIn>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
